import { render } from "./ViewsSurveyDeliveryFaq.vue?vue&type=template&id=3d534638"
import script from "./ViewsSurveyDeliveryFaq.vue?vue&type=script&lang=js"
export * from "./ViewsSurveyDeliveryFaq.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__